import React, { useState } from 'react';

// Recibe la función para añadir la tarea (que se encuentra en App.js) por 'props'
const TaskForm = ({ onAddTask }) => {
    const [newTaskText, setNewTaskText] = useState(''); // Estado local por el input

    const handleSubmit = (e) => {
        e.preventDefault();
        if (newTaskText.trim() === '') return;

        // Llama la función del padre, pasándole el texto de la tarea
        onAddTask(newTaskText);

        setNewTaskText(''); // Limpia el input
    };

    return (
        <form onSubmit={handleSubmit} className="task-form">
            <input
                type="text"
                value={newTaskText}
                onChange={(e) => setNewTaskText(e.target.value)}
                placeholder="Añade una nueva tarea..."
            />
            <button type="submit">Añadir</button>
        </form>
    );
};

export default TaskForm;